import React, { useCallback, useContext, useEffect, useState } from "react";
import { Container } from "components";
import Breadcrumb from "components/molecules/Breadcrumb";
import {
  MdOutlineCloudDownload,
  MdOutlineCheckCircleOutline,
  MdRestoreFromTrash,
  MdRefresh,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getData, patchData } from "actions";
import { API_URL_periodicTask } from "constants/api";
import { AuthContext } from "context/AuthContext";
import { cronReducers } from "redux/cronSlice";

const Cron = () => {
  const navigate = useNavigate();
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);
  const dispatch = useDispatch();
  const [cronEmailFetching, setCronEmailFetching] = useState("");
  const [cronAutocloseoverflow, setCronAutocloseoverflow] = useState("");
  const [cronResetSpamLimit, setCronResetSpamLimit] = useState("");
  const [cronDeleteLogQueue, setCronDeleteLogQueue] = useState("");
  const [cronDeleteLogs, setCronDeleteLogs] = useState("");
  const [cronNotificationDays, setCronNotificationDays] = useState("");

  const { getCronResult, addCronResult } = useSelector((state) => state.cron);

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_periodicTask,
        params,
        { dispatch, redux: cronReducers },
        "GET_CRON"
      );
    },
    [dispatch]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = [
      { name: "fetchIncomingEmail", crontab: cronEmailFetching },
      { name: "closeTicketWorkflow", crontab: cronAutocloseoverflow },
      { name: "deleteLogs", crontab: cronDeleteLogs },
      { name: "deleteLogsQueue", crontab: cronDeleteLogQueue },
      { name: "resetSpam", crontab: cronResetSpamLimit },
      { name: "deleteNotification", crontab: cronNotificationDays },
    ];
    //edit
    patchData(
      `${API_URL_periodicTask}patch/`,
      formData,
      { dispatch, redux: cronReducers },
      "ADD_CRON",
      () => {
        fetchData();
      }
    );
  };

  const fetchData = useCallback(() => {
    //get all of Apisetting
    const params = ``;
    get(params);
  }, [get]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (addCronResult) {
      fetchData();
    }
  }, [addCronResult]);

  useEffect(() => {
    //getCronResult get all name & crontab_id
    if (getCronResult) {
      const cron = {};
      getCronResult.forEach((item) => {
        cron[item.name] = item.crontab;
      });

      setCronEmailFetching(cron["fetchIncomingEmail"]);
      setCronAutocloseoverflow(cron["closeTicketWorkflow"]);
      setCronDeleteLogs(cron["deleteLogs"]);
      setCronDeleteLogQueue(cron["deleteLogsQueue"]);
      setCronResetSpamLimit(cron["resetSpam"]);
      setCronNotificationDays(cron["deleteNotification"]);
    }
  }, [getCronResult]);

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }
  return (
    <Container>
      <Breadcrumb
        title={"Settings"}
        excludedPaths={["setting", "administrator"]}
        group={"Superadmin"}
      />
      <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow">
        <div className="h-12 w-full grid items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600 text-xs md:text-base">
          Cron settings
        </div>

        <form onSubmit={handleSubmit}>
          <div className="px-4 py-2 grid grid-cols-12 gap-3">
            <div className="bg-white grid grid-cols-5 gap-2 col-span-full md:col-span-6 md:col-start-1 lg:col-span-6 lg:col-start-1 dark:bg-neutral-800 rounded overflow-hidden border border-neutral-300 py-2 px-2 overflow-x-auto ">
              <div className="col-span-1">
                <MdOutlineCloudDownload className="w-full h-full" />
              </div>
              <div className="col-span-2">
                <label className="text-sm">Email fetching:</label>
                <br />
              </div>
              <div className="col-span-2">
                <select
                  id="cronEmailFetching"
                  name="cronEmailFetching"
                  value={cronEmailFetching}
                  onChange={(e) => setCronEmailFetching(e.target.value)}
                  className="block w-full rounded-md border border-gray-500 bg-white py-2 px-2 text-gray-900 shadow-sm focus:ring-1 focus:ring-inset focus:ring-sky-400 sm:text-sm sm:leading-6"
                >
                  <option disabled value="">
                    Select
                  </option>
                  <option value={1}>Every Minute</option>
                  <option value={2}>Every Five Minute</option>
                  <option value={3}>Every Ten Minute</option>
                  <option value={4}>Every Thirty Minute</option>
                  <option value={5}>Every Hour</option>
                  <option value={6}>Every Day</option>
                  <option value={7}>Daily at</option>
                  <option value={8}>Every Week</option>
                </select>
              </div>
            </div>

            <div className="bg-white grid grid-cols-5 gap-2 col-span-full md:col-span-6 md:col-start-7 lg:col-span-6 lg:col-start-7 dark:bg-neutral-800 rounded overflow-hidden border border-neutral-300 py-2 px-2 overflow-x-auto ">
              <div className="col-span-1">
                <MdRestoreFromTrash className="w-full h-full" />
              </div>
              <div className="col-span-2">
                <label className="text-sm">Delete Logs Lastest 5 days</label>
                <br />
              </div>
              <div className="col-span-2">
                <select
                  id="cronDeleteLogs"
                  name="cronDeleteLogs"
                  value={cronDeleteLogs}
                  onChange={(e) => setCronDeleteLogs(e.target.value)}
                  className="block w-full rounded-md border border-gray-500 bg-white py-2 px-2 text-gray-900 shadow-sm focus:ring-1 focus:ring-inset focus:ring-sky-400 sm:text-sm sm:leading-6"
                >
                  <option disabled value="">
                    Select
                  </option>
                  <option value={1}>Every Minute</option>
                  <option value={2}>Every Five Minute</option>
                  <option value={3}>Every Ten Minute</option>
                  <option value={4}>Every Thirty Minute</option>
                  <option value={5}>Every Hour</option>
                  <option value={6}>Every Day</option>
                  <option value={7}>Daily at</option>
                  <option value={8}>Every Week</option>
                </select>
              </div>
            </div>
          </div>

          <div className="px-4 py-2 grid grid-cols-12 gap-3 mb-4">
            <div className="bg-white grid grid-cols-5 gap-2 col-span-full md:col-span-6 md:col-start-1 lg:col-span-6 lg:col-start-1  dark:bg-neutral-800 rounded overflow-hidden border border-neutral-300 py-2 px-2 overflow-x-auto ">
              <div className="col-span-1">
                <MdOutlineCheckCircleOutline className="w-full h-full" />
              </div>
              <div className="col-span-2">
                <label className="text-sm">Auto-close workflow</label>
                <br />
              </div>
              <div className="col-span-2">
                <select
                  id="cronAutocloseoverflow"
                  name="cronAutocloseoverflow"
                  value={cronAutocloseoverflow}
                  onChange={(e) => setCronAutocloseoverflow(e.target.value)}
                  className="block w-full rounded-md border border-gray-500 bg-white py-2 px-2 text-gray-900 shadow-sm focus:ring-1 focus:ring-inset focus:ring-sky-400 sm:text-sm sm:leading-6"
                >
                  <option disabled value="">
                    Select
                  </option>
                  <option value={1}>Every Minute</option>
                  <option value={2}>Every Five Minute</option>
                  <option value={3}>Every Ten Minute</option>
                  <option value={4}>Every Thirty Minute</option>
                  <option value={5}>Every Hour</option>
                  <option value={6}>Every Day</option>
                  <option value={7}>Daily at</option>
                  <option value={8}>Every Week</option>
                </select>
              </div>
            </div>

            <div className="bg-white grid grid-cols-5 gap-2 col-span-full md:col-span-6 md:col-start-7 lg:col-span-6 lg:col-start-7 dark:bg-neutral-800 rounded overflow-hidden border border-neutral-300 py-2 px-2 overflow-x-auto ">
              <div className="col-span-1">
                <MdRestoreFromTrash className="w-full h-full" />
              </div>
              <div className="col-span-2">
                <label className="text-sm">Delete Logs Queue</label>
                <br />
              </div>
              <div className="col-span-2">
                <select
                  id="cronDeleteLogsQueue"
                  name="cronDeleteLogsQueue"
                  value={cronDeleteLogQueue}
                  onChange={(e) => setCronDeleteLogQueue(e.target.value)}
                  className="block w-full rounded-md border border-gray-500 bg-white py-2 px-2 text-gray-900 shadow-sm focus:ring-1 focus:ring-inset focus:ring-sky-400 sm:text-sm sm:leading-6"
                >
                  <option disabled value="">
                    Select
                  </option>
                  <option value={1}>Every Minute</option>
                  <option value={2}>Every Five Minute</option>
                  <option value={3}>Every Ten Minute</option>
                  <option value={4}>Every Thirty Minute</option>
                  <option value={5}>Every Hour</option>
                  <option value={6}>Every Day</option>
                  <option value={7}>Daily at</option>
                  <option value={8}>Every Week</option>
                </select>
              </div>
            </div>
          </div>

          <div className="px-4 py-2 grid grid-cols-12 gap-3 mb-4">
            <div className="bg-white grid grid-cols-5 gap-2 col-span-full md:col-span-6 md:col-start-1 lg:col-span-6 lg:col-start-1  dark:bg-neutral-800 rounded overflow-hidden border border-neutral-300 py-2 px-2 overflow-x-auto ">
              <div className="col-span-1">
                <MdRefresh className="w-full h-full" />
              </div>
              <div className="col-span-2">
                <label className="text-sm">Reset Spam Limit</label>
                <br />
              </div>
              <div className="col-span-2">
                <select
                  id="cronResetSpamLimit"
                  name="cronResetSpamLimit"
                  value={cronResetSpamLimit}
                  onChange={(e) => setCronResetSpamLimit(e.target.value)}
                  className="block w-full rounded-md border border-gray-500 bg-white py-2 px-2 text-gray-900 shadow-sm focus:ring-1 focus:ring-inset focus:ring-sky-400 sm:text-sm sm:leading-6"
                >
                  <option disabled value="">
                    Select
                  </option>
                  <option value={1}>Every Minute</option>
                  <option value={2}>Every Five Minute</option>
                  <option value={3}>Every Ten Minute</option>
                  <option value={4}>Every Thirty Minute</option>
                  <option value={5}>Every Hour</option>
                  <option value={6}>Every Day</option>
                  <option value={7}>Daily at</option>
                  <option value={8}>Every Week</option>
                </select>
              </div>
            </div>

            <div className="bg-white grid grid-cols-5 gap-2 col-span-full md:col-span-6 md:col-start-7 lg:col-span-6 lg:col-start-7 dark:bg-neutral-800 rounded overflow-hidden border border-neutral-300 py-2 px-2 overflow-x-auto ">
              <div className="col-span-1">
                <MdRestoreFromTrash className="w-full h-full" />
              </div>
              <div className="col-span-2">
                <label className="text-sm">
                  Delete Read Notifications based on days to delete notification
                </label>
                <br />
              </div>
              <div className="col-span-2">
                <select
                  id="cronNotificationDays"
                  name="cronNotificationDays"
                  value={cronNotificationDays}
                  onChange={(e) => setCronNotificationDays(e.target.value)}
                  className="block w-full rounded-md border border-gray-500 bg-white py-2 px-2 text-gray-900 shadow-sm focus:ring-1 focus:ring-inset focus:ring-sky-400 sm:text-sm sm:leading-6"
                >
                  <option disabled value="">
                    Select
                  </option>
                  <option value={1}>Every Minute</option>
                  <option value={2}>Every Five Minute</option>
                  <option value={3}>Every Ten Minute</option>
                  <option value={4}>Every Thirty Minute</option>
                  <option value={5}>Every Hour</option>
                  <option value={6}>Every Day</option>
                  <option value={7}>Daily at</option>
                  <option value={8}>Every Week</option>
                </select>
              </div>
            </div>
          </div>

          <div className="h-12 w-full grid items-center px-4 bg-neutral-50 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="w-20 items-center p-1 px-3 rounded shadow-sm border text-white bg-blue-800 hover:bg-blue-700"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </Container>
  );
};

export default Cron;
